import '../styles/technologies-styles.css'

function LoadTechnologies() {

    const technologies = ['Python', 'TensorFlow', 'PyTorch', 'CNNS & GANS', 'MLOps', 'Computer Vision', 'NLP', 'Multi-Agent Orchestration']

    return (
        <div className="container" id="technologies">
            <div>
                <h2>Our Technology Foundation</h2>
                <p>We use a robust, modern stack to build powerful and scalable Al solutions.</p>
            </div>

            <div className='chips'>
                {technologies.map((tech, index) => (
                    <p key={index} className='chip'>{tech}</p>
                ))}
            </div>
        </div>
    )
}

export default LoadTechnologies;